import { Button, message } from "antd";
import { useEffect, useState } from "react";
import { SiMicrosoftexcel } from "react-icons/si";
import { excelStore } from "src/stores/excel-store.interface";
import { pdfStore } from "src/stores/pdf-store";
import { profileStore } from "src/stores/profile-store";
import { componentPalette } from "src/theme/component-palette";
import { BASE_URL, blob } from "src/utils/http-common";
import { useShallow } from "zustand/react/shallow";
import { capitalizeFirstLetter } from "src/utils/manage-string";
import { CommonError } from "src/entity/common/menus-enum.enum";
import { QueryFugitiveVocResult } from "src/entity/fugitive/fugitive.entity";
import { getQueryParams } from "src/utils/utils-object";
import { roundUpToNearestTen } from "src/utils/number";

const timeoutCalculation = 300000; // 5 minutes

const large_excel_path = ["/api/fugitive/voc-result/export-excel"];
const blackListPath = ["/api/flare", "/api/waste-water-treatment", "/api/others"];
const Excel = (props: { path: string }) => {
  const { path } = props;
  const profile = profileStore(useShallow((state) => state.profile));
  const companyName = profile?.activeCompany?.companyName;
  const [companyId, setCompanyId] = useState<string>("");
  const selectedYear = excelStore(useShallow((state) => state.selectedYear));
  const additionalOption = excelStore(useShallow((state) => state.additional));
  const queryStr = excelStore(useShallow((state) => state.queryStr));
  const queryStrPdf = pdfStore(useShallow((state) => state.filter));
  const [urlAPI, setUrlApi] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const excelSetQueryStr = excelStore(useShallow((state) => state.setQueryStr));

  const handleExcelError = () => {
    setLoading(false);
    messageApi.open({
      type: "error",
      content: CommonError.SOMETHING_WRONG,
    });
  };
  const exportExtraExcel = async (filter: QueryFugitiveVocResult, maxLength: number) => {
    const chunkSize = maxLength / 10;

    let limit = roundUpToNearestTen(chunkSize);

    for (let offset = 0; offset < maxLength; offset += limit) {
      const create_filter = { ...filter, offset, limit, isExtraLarge: true };
      const convertUrl = urlAPI.split("?");
      await blob
        .get(convertUrl[0], { timeout: timeoutCalculation, params: create_filter })
        .then((response) => {
          const link: any = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }));
          link.download = `${fileName.replace(".xlsx", `_${offset + 1}-${offset + limit}`)}.xlsx`;
          document.body.appendChild(link);

          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(link);
          }, 200);
        })
        .catch(handleExcelError);
    }
  };

  const exportExel = async () => {
    setLoading(true);
    if (blackListPath.some((a) => urlAPI.includes(a))) {
      // console.log("queryStr :: ", { queryStr, selectedYear });
      const mergeQuery = queryStr ? { ...JSON.parse(queryStr), year: [selectedYear.toString()] } : { year: [selectedYear.toString()] };
      await blob
        .post(urlAPI, mergeQuery)
        .then((response) => {
          const link: any = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }));
          link.download = fileName;
          document.body.appendChild(link);

          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(link);
          }, 200);
        })
        .catch(handleExcelError);
    } else {
      if (selectedYear) {
        if (large_excel_path.some((whl) => urlAPI.includes(whl)) && additionalOption > 30000) {
          const extractFilterFromUrlAPI = getQueryParams(BASE_URL + urlAPI) as unknown as QueryFugitiveVocResult;
          // console.log("extractFilterFromUrlAPI :: ", extractFilterFromUrlAPI);
          await exportExtraExcel({ year: extractFilterFromUrlAPI.year }, additionalOption);
        } else
          await blob
            .get(urlAPI, { timeout: timeoutCalculation })
            .then((response) => {
              const link: any = document.createElement("a");
              link.href = window.URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }));

              link.download = fileName;
              document.body.appendChild(link);

              link.click();
              setTimeout(function () {
                window.URL.revokeObjectURL(link);
              }, 200);
            })
            .catch(handleExcelError);
      }
    }
    setLoading(false);
  };

  const intitalData = () => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }
  };

  useEffect(() => {
    intitalData();
  }, [profile?.activeCompany]);

  // UseEffect -> Sequence 2
  useEffect(() => {
    // console.log("[Excel] Trigger : ", { queryStr, selectedYear });

    if (path === "/vocs-inventory/combustion/report-fuel-volume") {
      setUrlApi(`/api/combustion/report/fuel-volume/export-excel/${companyId}?${queryStr}`);
      setFileName(`FuelVolume-Report-${selectedYear}.xlsx`);
    } else if (path === "/vocs-inventory/combustion/report-voc-emission") {
      setFileName(`${companyName}-VOCsEmission-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/combustion/report/voc-emission/export-excel/${companyId}?${queryStr}`);
    } else if (path === "/vocs-inventory/transportation-and-marketing/report-chemical-volume") {
      setFileName(`${companyName}-TransportationChemicalVolume-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/transportation-marketing/report/chemical-volume/export-excel/${companyId}?${queryStr}`);
    } else if (path === "/vocs-inventory/flare/report-flare-volume") {
      console.log("[Excel] selected year : ", { selectedYear, queryStr });
      setFileName(`${companyName}-FlareVolume-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/flare/export-excel/report-flare-volume`);
    } else if (path === "/vocs-inventory/transportation-and-marketing/report-voc-emission") {
      setFileName(`${companyName}-TransportationVOCsEmission-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/transportation-marketing/report/voc-emission/export-excel/${companyId}?${queryStr}`);
    } else if (path === "/vocs-inventory/flare/report-voc-emission") {
      setFileName(`${companyName}-FlareVOCsEmission-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/flare/export-excel/report-voc-emission`);
    } else if (path === "/vocs-inventory/flare/report-government") {
      const suffixFileName = `${!queryStrPdf?.month || !queryStrPdf?.year ? "" : `-${capitalizeFirstLetter(queryStrPdf?.month)}-${queryStrPdf?.year}`}`;
      setFileName(`${companyName}-รายงานราชการ${suffixFileName}.xlsx`);
      setUrlApi(`/api/flare/export-excel/report-government`);
    } else if (path === "/vocs-inventory/waste-water-treatment/report-voc-emission") {
      setFileName(`${companyName}-WasteWaterVOCsEmission-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/waste-water-treatment/export-excel/report-voc-emission`);
    } else if (path === "/vocs-inventory/tank/report-voc-emission") {
      setFileName(`${companyName}-TankVOCsEmission-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/tank/report/voc-emission/export-excel?${queryStr}`);
    } else if (path === "/vocs-inventory/fugitive/information-voc-result") {
      setFileName(`${companyName}-FugitiveVOCsResult-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/fugitive/voc-result/export-excel?${queryStr}`);
    } else if (path === "/vocs-inventory/fugitive/information-stop-voc") {
      setFileName(`${companyName}-FugitiveStopVOCs-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/fugitive/stop-voc/export-excel?${queryStr}`);
    } else if (path === "/vocs-inventory/fugitive/report-voc-series") {
      setFileName(`${companyName}-FugitiveVOCsSeries-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/fugitive/report/voc-series/export-excel?${queryStr}`);
    } else if (path === "/vocs-inventory/fugitive/report-voc-emission") {
      setFileName(`${companyName}-FugitiveVOCsEmission-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/fugitive/report/voc-emission/export-excel?${queryStr}`);
    } else if (path === "/production") {
      setFileName(`Production-${selectedYear}.xlsx`);
      setUrlApi(`/api/production/export-excel${queryStr}`);
    } else if (path === "/vocs-inventory/others/report") {
      setFileName(`${companyName}-Others-Report-${selectedYear}.xlsx`);
      setUrlApi(`/api/others/export-excel/report-voc-emission`);
    } else if (path === "/report") {
      let jsonObject: any = "{}";

      try {
        jsonObject = queryStr ? JSON.parse(queryStr) : {};
      } catch (error) {
        excelSetQueryStr("{}");
        jsonObject = {};
      }
      const selectedYearReport = "year" in jsonObject && jsonObject?.year ? JSON.parse(jsonObject.year) : [];
      const finalFileName = `Report-${JSON.stringify(Array.isArray(selectedYearReport) ? selectedYearReport.join(",") : selectedYearReport || selectedYear)}.xlsx`;
      setFileName(finalFileName.replaceAll('"', ""));
      // Parse the JSON string into an object
      // Create URLSearchParams from the object
      const newQueryString = new URLSearchParams(jsonObject).toString();
      setUrlApi(`/api/report/export-excel?${newQueryString}`);
    }
  }, [path, queryStr, companyId, selectedYear]);

  return (
    <div>
      {contextHolder}
      <Button
        type="text"
        loading={loading}
        icon={<SiMicrosoftexcel style={{ fontSize: "28px", color: componentPalette.excelColor }} onClick={exportExel} />}
      />
    </div>
  );
};

export default Excel;
